import { render, staticRenderFns } from "./bill-success.vue?vue&type=template&id=38948fbb&"
import script from "./bill-success.vue?vue&type=script&lang=js&"
export * from "./bill-success.vue?vue&type=script&lang=js&"
import style0 from "./bill-success.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports